import { View } from "react-native"
import LottieView from "lottie-react-native"

export default function LoadingBouncingBalls() {
  return (
    <View className="flex flex-1 items-center justify-center">
      <LottieView
        source={require("@/assets/lottie/bouncing-balls_animation.json")}
        style={{
          width: 128,
          height: 128,
        }}
        loop={true}
        autoPlay
      />
    </View>
  )
}
